import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';

import { EnumHelpers } from '@app/Services/EnumHelpers';
import { ContractPartTimeSplitType, ContractPartTimeSplitTypes } from '@app/Models';

type ChangeContractDefinitionHandler = (value: number) => void;
type ChangeSplitTypeHandler = (type: ContractPartTimeSplitType) => void;

type ContractPartTimeDayBlockProps = {
    onChangeContractDefinition: ChangeContractDefinitionHandler;
    onChangeSplitType: ChangeSplitTypeHandler;
    contractDefinition?: number;
    splitType?: ContractPartTimeSplitType;
    className?: string;
    disabled?: boolean;
};

export class ContractPartTimeDayBlock extends React.PureComponent<ContractPartTimeDayBlockProps, {}>{
    private _store: ContractPartTimeDayBlockStore;

    constructor(props: ContractPartTimeDayBlockProps) {
        super(props);
        this._store = new ContractPartTimeDayBlockStore(props);
    }

    render(){
        return(
            <>
                <Dropdown
                    label="Contract Definition"
                    options={this._store.dayContractDefinitionOptions}
                    onChange={this._store.onChangeContractDefinition}
                    selectedKey={this.props.contractDefinition}
                    required
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Split Type"
                    options={this._store.contractSplitTypeOptions}
                    onChange={this._store.onChangeSplitType}
                    selectedKey={this.props.splitType as string}
                    required
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
            </>
        );
    }
}

class ContractPartTimeDayBlockStore {
    private readonly _onChangeContractDefinitionFunction: ChangeContractDefinitionHandler;
    private readonly _onChangeSplitTypeFunction: ChangeSplitTypeHandler;

    constructor(props: ContractPartTimeDayBlockProps) {
        this._onChangeContractDefinitionFunction = props.onChangeContractDefinition;
        this._onChangeSplitTypeFunction = props.onChangeSplitType;
    }

    onChangeContractDefinition = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeContractDefinitionFunction(option.key as number);
        }
    };
    
    onChangeSplitType = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeSplitTypeFunction(option.key as ContractPartTimeSplitType);
        }
    };

    public get dayContractDefinitionOptions() {
        return [
            { key: 40, text: '40' },
            { key: 50, text: '50' },
            { key: 60, text: '60' },
            { key: 70, text: '70' },
            { key: 80, text: '80' },
            { key: 90, text: '90' }
        ];
    }

    public get contractSplitTypeOptions() {
        return EnumHelpers.toKeyValueArray(ContractPartTimeSplitTypes);
    }
}